import {LoginHelper} from './login.helper';
import {Keys, StorageService} from '../service/storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PageMapping} from '../utils/PageMapping';
import {Injectable} from '@angular/core';
import {NomineeService} from '../service/nominee.service';
import {PreferencesService} from '../service/preferences.service';

@Injectable()
export class PreApprovalLoginHelper extends LoginHelper {
    constructor(storageService: StorageService, route: ActivatedRoute, router: Router, pageMapping: PageMapping,
                nomineeService: NomineeService, preferenceService: PreferencesService) {
        super(storageService, route, router, pageMapping, nomineeService, preferenceService);
    }

    public async redirectUser(): Promise<void> {
         await this.router.navigate(['/borrow/dashboard/applications']);
    }

    public async saveLoanDetails(): Promise<void> {
        this.storageService.saveItem(Keys.BORROWER, 'true');
    }
}
